<script>
    import Inputmask from "inputmask";
    import {VTextField} from 'vuetify/lib';

    export default {
        name: 'VDateField',
        extends: VTextField,
        props: {
            inputmaskPlaceholder: {
                type: String,
                default () {
                    return "9999-99-99"
                }
            },
            placeholder: {
                type: String,
                default () {
                    return 'aaaa-ll-zz'
                }
            }
        },
        mounted() {
            let input = this.$el.querySelector('input')
            if (input) {
                Inputmask(this.inputmaskPlaceholder, {
                    rightAlign: false,
                    placeholder: this.placeholder
                }).mask(input);
            }
        }
    }
</script>
